import React from "react";
import FactureFromDevisBase from "./_shared/FactureFromDevisBase";
export default function FactureAcompte() {
  return <FactureFromDevisBase type="acompte" />;
}
